"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreLineChart = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var BaseChart_1 = require("../_base/BaseChart");
var CoreLineChart = /** @class */ (function (_super) {
    tslib_1.__extends(CoreLineChart, _super);
    function CoreLineChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CoreLineChart.prototype.render = function () {
        return react_1.default.createElement(BaseChart_1.BaseChart, tslib_1.__assign({ type: "line" }, this.props));
    };
    return CoreLineChart;
}(react_1.default.PureComponent));
exports.CoreLineChart = CoreLineChart;
//# sourceMappingURL=CoreLineChart.js.map